export const LEGAL_DOCUMENTS = [
  {
    slug: "client-agreement",
    title: "Client Agreement",
    filePath: "/docs/Client%20agreement%20Treefield.pdf",
    fileType: "PDF",
  },
  {
    slug: "privacy-policy",
    title: "Privacy Policy",
    filePath: "/docs/PRIVACY%20POLICY%20Treefield.pdf",
    fileType: "PDF",
  },
  {
    slug: "conflict-of-interests",
    title: "Conflict of Interests Policy",
    filePath: "/docs/CONFLICT%20OF%20INTERESTS%20Treefield.pdf",
    fileType: "PDF",
  },
];
